module.exports = require('./helpers/bundle-url').getBundleURL('fx0PE') + "logo.c51670a8.svg";